/**
 *
 * @param id:String 全局唯一ID
 * @param name:String 页面名称
 * @param des:String 页面描述
 * @param module:String 所属模块
 * @param classify:String/[String] 页面分类，多个逗号隔开
 * @param webPath:String/[String] web访问路径，多个逗号隔开
 * @param webFunIds:String/[String] 功能ID，来自接口webFun标记的ID值，多个用逗号隔开
 * @param props:{key:value} 页面属性配置 key:名称 value:描述
 * @returns {function(...[*]=)}
 * @constructor
 */
export function WebPage({id, name, des, module, classify, webPath, webFunIds, props} = {}) {
    return function (target) {
        target.prototype._webPage = {id, name, des, module, classify, webPath, webFunIds, props};
    }
}
